/**
 * Gallery scene: Create in folder (?test=maater-ui#create-in-folder)
 *
 * Shared + New: empty desk, tab-bar split, folder context submenu.
 * Import: CreateInFolderDropdown + @/lib/create-in-folder
 */
import { Plus } from 'lucide-react'
import { CreateInFolderDropdown } from '@/components/ui/create-in-folder-menu'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { CREATE_IN_FOLDER_ACTIONS, CREATE_IN_FOLDER_SUBMENU_LABEL } from '@/lib/create-in-folder'
import { QUIET_OVERFLOW_MENU_CONTENT_COMPACT_CLASS } from '@/lib/menu-chrome'
import { testIds } from '@/lib/test-ids'

export function CreateInFolderScene() {
  return (
    <div className="space-y-8" data-testid={testIds.maaterUiGallery.createInFolder}>
      <p className="text-sm text-muted-foreground">
        Same three actions everywhere: New document, Import, New folder. Tab bar keeps a primary
        click (create document in the resolved folder) plus Choose folder. Folder right-click nests
        them under New.
      </p>

      <section className="space-y-2">
        <h3 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
          Empty desk
        </h3>
        <CreateInFolderDropdown variant="empty" onAction={() => undefined} />
      </section>

      <section className="space-y-2">
        <h3 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
          Tab bar split
        </h3>
        <div className="inline-flex items-end border-l border-border/60 pl-1.5 pr-1.5">
          <CreateInFolderDropdown
            variant="tab-bar"
            onPrimaryClick={() => undefined}
            onAction={() => undefined}
            onChooseFolder={() => undefined}
            documentLabel="New document in Personal"
          />
        </div>
      </section>

      <section className="space-y-2">
        <h3 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
          Folder right-click (New submenu)
        </h3>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button
              type="button"
              className="h-7 rounded-md px-2 text-xs font-medium text-muted-foreground hover:bg-muted/50 hover:text-foreground"
            >
              Open sample menu
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            align="start"
            className={QUIET_OVERFLOW_MENU_CONTENT_COMPACT_CLASS}
          >
            <DropdownMenuItem disabled>Search in folder</DropdownMenuItem>
            <DropdownMenuSub>
              <DropdownMenuSubTrigger>
                <Plus className="h-3.5 w-3.5" />
                {CREATE_IN_FOLDER_SUBMENU_LABEL}
              </DropdownMenuSubTrigger>
              <DropdownMenuSubContent className={QUIET_OVERFLOW_MENU_CONTENT_COMPACT_CLASS}>
                {CREATE_IN_FOLDER_ACTIONS.map((action) => {
                  const Icon = action.icon
                  return (
                    <DropdownMenuItem key={action.id}>
                      <Icon className="h-3.5 w-3.5" />
                      {action.label}
                    </DropdownMenuItem>
                  )
                })}
              </DropdownMenuSubContent>
            </DropdownMenuSub>
          </DropdownMenuContent>
        </DropdownMenu>
      </section>
    </div>
  )
}
